import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../alert.service';
import { AlertMessage } from '../../../models/Alert.model';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-alert.component.html',
  styleUrls: ['./app-alert.component.scss']
})
export class AppAlertComponent {

  alert: AlertMessage = {
    type: 'info',
    message: '',
    visible: false
  };

  constructor(private alertService: AlertService) {
    debugger
    this.alertService.alert$.subscribe(res => {
      this.alert = res;
    });
  }

  close(): void {
    debugger
    this.alertService.hide();
  }
}